import { Autocomplete, Button, Grid, TextField } from "@mui/material";
import withRole from "../../Hooks/withRole";
import { CourseFormProps } from "../../Utils/Types";
import { Vocabulary } from "../../Utils/Vocabulary";
import GenericModal from "../GenericModal";
import { useEffect, useState } from "react";
import { postData } from "../../Services/postData";
import { endpoints } from "../../Utils/UrlEnum";
import { CourseModel } from "../../Utils/Models";
import { updateData } from "../../Services/updateData";

function CourseForm(props: CourseFormProps) {
  const { open, onClose, selectedRow, products } = props;
  const [data, setData] = useState(selectedRow);

  useEffect(() => {
    setData(selectedRow);
  }, [selectedRow]);
  /**
   * Posts the course data to the server, and resets the form.
   * Closes the modal on success.
   * @returns {Promise<void>}
   */
  const submit = async () => {
    const response = data?._id
      ? await updateData(endpoints.courses + `/${data._id}`, data)
      : await postData(endpoints.courses, data);
    if (response && response?.data) {
      onClose();
      setData(new CourseModel());
    }
  };

  return (
    <div>
      <GenericModal open={open} onClose={onClose} title={Vocabulary.addCourse}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12}>
            <TextField
              fullWidth
              required
              name="name"
              label={Vocabulary.name}
              value={data?.name}
              onChange={(e) => setData({ ...data, name: e.target.value })}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <TextField
              fullWidth
              required
              type="number"
              name="sortOrder"
              value={data?.sortNumber}
              label={Vocabulary.sortNumber}
              onChange={(e) =>
                setData({ ...data, sortNumber: parseInt(e.target.value) })
              }
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <Autocomplete
              multiple
              fullWidth
              options={products || []}
              getOptionLabel={(option) => option.name || ""}
              value={data?.productsIds || []}
              onChange={(_, newValue) => {
                setData({ ...data, productsIds: newValue });
              }}
              renderInput={(params) => (
                <TextField {...params} label={Vocabulary.products} />
              )}
            />
          </Grid>

          <Grid item xs={12} sm={12} md={12}>
            <Button onClick={submit} variant="contained" fullWidth>
              {Vocabulary.save}
            </Button>
          </Grid>
        </Grid>
      </GenericModal>
    </div>
  );
}

export default withRole(CourseForm);
